import { useMemo } from 'react'
import { cellTemplates } from '../../constants/cellTemplates'
import { InfographicBlockActionsCell } from '../components/InfographicBlockActionsCell'

export const useInfographicBlockColumnConfig = ({
  userIsInternal,
  onRefetch
}) => {
  return useMemo(() => ({
    columns: [
      {
        Header: 'Id',
        accessor: 'infographicBlockId',
        id: 'infographicBlockId',
        width: 60,
        disableSortBy: false
      },
      {
        Header: 'Name',
        accessor: 'name',
        id: 'name'
      },
      {
        Header: 'Ordinal',
        accessor: 'ordinal',
        id: 'ordinal'
      },
      ...(userIsInternal && [{
        Header: 'Internal Only?',
        accessor: 'internal',
        id: 'internal',
        width: 100,
        Cell: cellTemplates.boolean
      }]),
      {
        Header: 'Actions',
        accessor: 'infographicBlockId',
        id: 'infographicBlockIdActions',
        Cell: ({ row }) => InfographicBlockActionsCell({ row, onRefetch })
      }
    ],
    defaultSort: [
      { id: 'ordinal', desc: false }
    ],
    defaultPageSize: 20
  }), [onRefetch, userIsInternal])
}
